//codex--
import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getFullSchedulerDefault, normalizeSchedulerDepartment } from '../utils/fullSchedulerSettings';

//codex--
export default function useSchedulerDepartment(apiUrl) {
  const [selectedDept, setDepartment] = useState('Field');
  const manuallySelected = useRef(false);
  const navigate = useNavigate();

  //codex--
  useEffect(() => {
    let active = true;
    getFullSchedulerDefault(apiUrl)
      .then((department) => {
        if (active && !manuallySelected.current) setDepartment(department);
      })
      .catch((error) => {
        if (!active) return;
        if (error.response?.status === 401) navigate('/login');
        else toast.error('Could not load your default department.', { position: 'top-center' });
      });
    return () => { active = false; };
  }, [apiUrl, navigate]);

  //codex--
  const setSelectedDept = useCallback((department) => {
    manuallySelected.current = true;
    setDepartment(normalizeSchedulerDepartment(department));
  }, []);

  return [selectedDept, setSelectedDept];
}
